import { useState } from "react";
import { API_KEY } from "./Dashboard";


const USERS_BASE_ID = "applct9YTCwkvXpey";
const USERS_URL = `https://api.airtable.com/v0/${USERS_BASE_ID}/Users`;
const H = { Authorization: `Bearer ${API_KEY}` };

async function fetchAllUsers() {
  const all = [];
  let off = null;
  do {
    const url = `${USERS_URL}?pageSize=100${off ? `&offset=${off}` : ""}`;
    const r = await fetch(url, { headers: H });
    const d = await r.json();
    if (d.records) all.push(...d.records);
    off = d.offset || null;
  } while (off);
  return all.map(r => ({ _id: r.id, ...r.fields }));
}

export { USERS_URL, H, fetchAllUsers, USERS_BASE_ID };

export default function Login({ onLogin }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const users = await fetchAllUsers();
      const match = users.find(
        u => u.username === username.trim() && u.password === password
      );
      if (!match) {
        setError("Invalid username or password.");
      } else {
        onLogin({
          _id: match._id,
          username: match.username,
          role: match.role || "user",
          baseid: match.baseid || "",
        });
      }
    } catch (err) {
      setError("Failed to connect. Check your internet connection.");
    }
    setLoading(false);
  };

  return (
    <div style={{
      minHeight: "100vh", background: "#F8F9FB",
      fontFamily: "'Outfit', system-ui, sans-serif",
      display: "flex", alignItems: "center", justifyContent: "center"
    }}>
      <link href="https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;500;600;700;800&display=swap" rel="stylesheet"/>
      <div style={{
        background: "#fff", border: "1px solid #E5E7EB", borderRadius: 18,
        padding: "40px 44px", width: "100%", maxWidth: 400,
        boxShadow: "0 8px 40px rgba(0,0,0,0.07)"
      }}>
        <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 28 }}>
          <div style={{
            width: 40, height: 40, borderRadius: 10,
            background: "linear-gradient(135deg, #3B82F6, #8B5CF6)",
            display: "flex", alignItems: "center", justifyContent: "center"
          }}>
            <span style={{ color: "#fff", fontWeight: 800, fontSize: 18 }}>L</span>
          </div>
          <div>
            <h1 style={{ fontSize: 20, fontWeight: 750, margin: 0, letterSpacing: "-0.03em" }}>LYNCO by 100XAI</h1>
            <p style={{ fontSize: 12, color: "#9CA3AF", margin: 0 }}>Sign in to your dashboard</p>
          </div>
        </div>

        <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", gap: 16 }}>
          <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
            <label style={{ fontSize: 13, fontWeight: 600, color: "#374151" }}>Username</label>
            <input
              value={username}
              onChange={e => setUsername(e.target.value)}
              required
              autoComplete="username"
              style={{
                padding: "10px 14px", fontSize: 14, border: "1px solid #E5E7EB",
                borderRadius: 9, outline: "none", transition: "border .15s",
                fontFamily: "inherit"
              }}
              onFocus={e => e.target.style.borderColor = "#3B82F6"}
              onBlur={e => e.target.style.borderColor = "#E5E7EB"}
            />
          </div>
          <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
            <label style={{ fontSize: 13, fontWeight: 600, color: "#374151" }}>Password</label>
            <input
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              required
              autoComplete="current-password"
              style={{
                padding: "10px 14px", fontSize: 14, border: "1px solid #E5E7EB",
                borderRadius: 9, outline: "none", transition: "border .15s",
                fontFamily: "inherit"
              }}
              onFocus={e => e.target.style.borderColor = "#3B82F6"}
              onBlur={e => e.target.style.borderColor = "#E5E7EB"}
            />
          </div>

          {error && (
            <div style={{
              background: "#FEF2F2", border: "1px solid #FECACA", borderRadius: 8,
              padding: "10px 14px", fontSize: 13, color: "#DC2626"
            }}>
              {error}
            </div>
          )}

          <button
            type="submit"
            disabled={loading}
            style={{
              padding: "11px", fontSize: 14, fontWeight: 700,
              background: loading ? "#93C5FD" : "linear-gradient(135deg, #3B82F6, #8B5CF6)",
              color: "#fff", border: "none", borderRadius: 10,
              cursor: loading ? "not-allowed" : "pointer", marginTop: 4,
              fontFamily: "inherit", letterSpacing: "0.01em"
            }}
          >
            {loading ? "Signing in…" : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}
